import React from 'react';
import { Link } from 'react-router-dom';
import { LandingCTABand } from '../../landing-system';

/**
 * Kloutsale final CTA — delegates the band shell to LandingCTABand (light
 * tone = solid accent bg + slate text). Heading/description/buttons stay
 * here so brand copy lives with the brand.
 */
export default function CTA() {
  return (
    <LandingCTABand
      tone="light"
      heading="Build something worth sharing. Let the right people share it."
      description="Your store remains the home base. Kloutsale helps the right people introduce it, recommend it, and turn that trust into measurable sales."
      cta={
        <>
          <Link
            to="/signup"
            className="rounded-full bg-slate-950 px-7 py-3.5 text-base font-medium text-white transition hover:bg-slate-900"
          >
            Start with Kloutsale
          </Link>
          <a
            href="#how-it-works"
            className="rounded-full border border-slate-950/20 px-7 py-3.5 text-base font-medium text-slate-950 transition hover:bg-slate-50/20"
          >
            See how it works
          </a>
        </>
      }
    />
  );
}
